export default __webpack_public_path__ + "static/media/cam-ic.a5d0b326.svg";